import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateSurveyDashboardPreferencesRPC } from "./updateSurveyDashboardPreferencesRPC";

export class UpdateSurveyDashboardPreferencesRPCClientImpl extends UpdateSurveyDashboardPreferencesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateSurveyDashboardPreferencesRPC.Request): Promise<LeoRPCResult<UpdateSurveyDashboardPreferencesRPC.Response, UpdateSurveyDashboardPreferencesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/UpdateSurveyDashboardPreferences",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateSurveyDashboardPreferencesRPC.ResponseDTO,
      UpdateSurveyDashboardPreferencesRPC.Errors.ErrorsDTO,
      UpdateSurveyDashboardPreferencesRPC.Response,
      UpdateSurveyDashboardPreferencesRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/UpdateSurveyDashboardPreferences",
      UpdateSurveyDashboardPreferencesRPC.Response.fromDTO,
      UpdateSurveyDashboardPreferencesRPC.Errors.fromDTO
    );
  }
}
